import { TagFamilyMemberType } from '../../../../../schemas/index';
import { ROOT_NODE_NAME } from '../../../../Products/UpsertTaggingWorkflowDrawer/JobInfo/TagsFamily/utils';
import { TreeSelectDataNode } from './types';

export function tagFamilyToTreeData(
  tagFamily: Array<TagFamilyMemberType>,
): Array<TreeSelectDataNode> {
  if (
    tagFamily.length > 0 &&
    tagFamily[0].name === ROOT_NODE_NAME &&
    Array.isArray(tagFamily[0].children)
  ) {
    return tagFamilyToTreeData(tagFamily[0].children);
  }
  return tagFamily.map(tag => ({
    title: tag.name,
    value: tag.name,
    key: tag.name,
    children: tag.children ? tagFamilyToTreeData(tag.children) : undefined,
    checkable: Array.isArray(tag.children) && tag.children.length > 0 ? false : true,
  }));
}

export function findNodePath(
  tree: Array<TreeSelectDataNode>,
  targetValue: string,
): Array<string> | null {
  function dfs(nodes: Array<TreeSelectDataNode>, currentPath: Array<string>): Array<string> | null {
    for (const node of nodes) {
      const newPath = [...currentPath, node.value];

      if (node.value === targetValue) {
        return newPath;
      }

      if (node.children && node.children.length > 0) {
        const result = dfs(node.children, newPath);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  return dfs(tree, []);
}

export function handleTreeCheck(
  checked: any,
  allTagOptions: Array<TreeSelectDataNode>,
): Array<string> {
  let checkedArr: Array<string> = [];
  if (Array.isArray(checked)) {
    checkedArr = checked as Array<string>;
  } else if (checked && Array.isArray((checked as any).checked)) {
    checkedArr = (checked as any).checked as Array<string>;
  }

  // Get only leaf nodes that are actually checkable and checked
  const selectedLeafNodes = checkedArr.filter(tag => {
    // Find the node in the tree to check if it's a leaf
    const findNode = (nodes: Array<TreeSelectDataNode>): TreeSelectDataNode | null => {
      for (const node of nodes) {
        if (node.value === tag) return node;
        if (node.children) {
          const found = findNode(node.children);
          if (found) return found;
        }
      }
      return null;
    };

    const node = findNode(allTagOptions);
    return node && (!node.children || node.children.length === 0) && node.checkable !== false;
  });

  const finalSelectedTags = new Set<string>();

  selectedLeafNodes.forEach(leafTag => {
    const path = findNodePath(allTagOptions, leafTag);
    if (path) {
      path.forEach(pathNode => finalSelectedTags.add(pathNode));
    }
  });

  return Array.from(finalSelectedTags).filter(tag => tag !== ROOT_NODE_NAME);
}
